export const API_BASE_URL= "https://www.makebeapp.com.br/api/makebe-session/"
export const API_BASE_AGENDA_URL= "https://www.makebeapp.com.br/api/makebe-agenda/"

// export const API_BASE_URL= "https://makebeappdev/api/makebe-session/"
// export const API_BASE_AGENDA_URL= "https://makebeappdev/api/makebe-agenda/"

// export const API_BASE_URL= "https://localhost:44368/"
// export const API_BASE_AGENDA_URL= "https://localhost:44330/"


export const URL_IMAGENS = "https://www.makebeapp.com.br/imagens";
export const RECAPTCHA_SITE_KEY = "6LfX6CgtAAAAAE-uz_RXIwqdu4YdIrt2GzXGaITg";
